<template>
  <div class="my-electronic-pass">
    <div class="header">
      <van-image width="100" height="50" :src="srcLogo1"/>
      <template v-if="!isEmpty">
        <div style="text-align: center; margin-top: -35px;" @click="switchTheElectronicPass">
          <span>{{ userName }}</span>
          <van-icon name="arrow-down" size="20px" style="margin-left: 10px;"/>
        </div>
        <!--        <van-popup v-model="show" position="bottom" custom-style="height: 40%;" bind:close="onClose">-->
        <!--          <van-picker title="请选择" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="onCancel"-->
        <!--                      @change="onChange" class="choiceApprovalOperator"/>-->
        <!--        </van-popup>-->
        <vg-pass-card-picker :visible.sync="show"
                             :items="passCardList"
                             :id="passCardInfo.id"
                             @update:show="onUpdateShow"
                             @on-confirm="onConfirm"/>

        <div style="text-align: end; margin-top: -20px; margin-right: 20px;">
          <span style="color: #4BA9F6;" @click="onNotes">使用须知</span>
        </div>
        <van-overlay :show="showNotes" :z-index="10" @click="showNotes = false">
          <div class="notes" @click.stop>
            <div class="notes-vg">
              <div class="notes-bg">
                <div class="notes-title">{{ noteTitle }}</div>
                <div class="notes-content">{{ noteContent }}</div>
              </div>
              <van-image style="margin-top: 13px;" width="32" height="32" :src="srcClose" @click="showNotes = false"/>
            </div>
          </div>
        </van-overlay>
      </template>
    </div>

    <template v-if="isEmpty">
      <div style="text-align: center; height:60vh; display: flex; flex-direction: column; justify-content: center">
        <div v-if="canOperate" @click="clickApply">
          <div>
            <van-image width="150" height="150" :src="defaultLogo"/>
          </div>
          <!-- <div style="margin-top: 20px; color: #666666;">
            <span>暂无有效电子出入证</span>
          </div> -->
          <div  style="margin-top: 10px; color: #4BA9F6; font-size: 1.5em;" >
            <span>点击申请</span>
          </div>
        </div>
      </div>
      <vg-button-group v-if="canOperate">
        <vg-button type="primary" @click.native="onApplicationRecord">我的申请记录</vg-button>
      </vg-button-group>
      <!--      <div class="footer">-->
      <!--        <van-button-->
      <!--            style=" width: 300px; height: 35px; background-color: #4BA9F6; color: white; border-radius: 10px;"-->
      <!--            @click.native="register">我的申请记录-->
      <!--        </van-button>-->
      <!--      </div>-->
    </template>
    <template v-else>
      <div style="text-align: center; margin-top: 20%;">
        <span
            :class="{'text-active': isActive, 'text-expired': isExpired, 'text-ineffective': isIneffective, 'text-cancelled': isCancelled}">{{
            validTime
          }}</span>
        <div
            :class="{'box-active': isActive, 'box-expired': isExpired, 'box-ineffective': isIneffective, 'box-cancelled': isCancelled}"
            style="width: 240px; height: 240px; display: block; margin: 20px auto 15px; padding: 5px; position: relative;">
          <div id="qrcode"></div>
          <van-image v-if="!isActive" class="qrmask" width="205" height="156"
                     :src="isExpired?srcExpired:isIneffective?srcIneffective:srcCancelled"/>
        </div>
        <span :style="isActive?'visibility: visible':'visibility: hidden'"
              style="font-size: 14px;">二维码1分钟自动刷新，请勿截图使用</span>
        <div :style="isActive?'visibility: visible':'visibility: hidden'" style="margin-top: 15px;">
          <van-button icon="replay" type="info" style="width: 130px; height: 34px; border-radius: 50px;"
                      @click="onRefresh">刷新二维码
          </van-button>
        </div>
      </div>
      <div class="person" @click="viewProfile()">
        <div class="item-content">
          <div class="item-text">个人资料</div>
          <div class="item-entry">
            <div class="item-title">姓名：</div>
            <div class="item-text">{{ userName }}</div>
          </div>
          <div class="item-entry">
            <div class="item-title">手机号：</div>
            <div class="item-text">{{ userPhone }}</div>
          </div>
        </div>
        <div class="item-arrow"/>
      </div>
      <!--      <div-->
      <!--          style="width: 346px; height: 120px; border: 1px solid #E7E5E7; border-radius: 10px; margin-left: 8%; margin-top: 20px; margin-bottom: 15px;"-->
      <!--          @click="viewProfile('2')">-->
      <!--        <div style="margin-top: 10px; margin-left: 15px;">-->
      <!--          <span>个人资料</span>-->
      <!--        </div>-->
      <!--        <van-cell title="姓名" is-link :value="userName" style=" width: 94%; padding-right: 10px;"/>-->
      <!--        <EqCell title="手机号" :value="userPhone"></EqCell>-->
      <!--      </div>-->
      <vg-button-group v-if="canOperate">
        <vg-button type="primary" @click.native="onApplicationRecord">我的申请记录</vg-button>
        <vg-button type="primary" @click.native="clickApply">申请电子出入证</vg-button>
      </vg-button-group>
      <!--      <div style="text-align: center; margin-top: 25px;">-->
      <!--        <van-button-->
      <!--            style=" width: 170px; height: 44px; background-color: #4BA9F6; color: white; border-radius: 10px;"-->
      <!--            @click.native="register">我的申请记录-->
      <!--        </van-button>-->
      <!--        <van-button-->
      <!--            style=" width: 170px; height: 44px; background-color: #4BA9F6; color: white; border-radius: 10px; margin-left: 11px;"-->
      <!--            @click.native="clickApply('2')">申请电子出入证-->
      <!--        </van-button>-->
      <!--      </div>-->
    </template>
  </div>
</template>
<script>

import QRCode from 'qrcode2';
import {Image, Button, Icon, Overlay, Dialog} from 'vant';
import srcLogo from "@/assets/login/kaidelogo.png";
import defaultPicture from "@/assets/myElectronicPass/defaultPicture.png";
import {client} from "@/libraries/http";
import VgPassCardPicker from "@/components/VgPassCardPicker";
import srcClose from "@/assets/icon-close.svg";
import srcExpired from "@/assets/scanverify/expired.png";
import srcIneffective from "@/assets/scanverify/ineffective.png";
import srcCancelled from "@/assets/scanverify/cancelled.png";
import VgButton from "@/components/Commons/VgButton";
import VgButtonGroup from "@/components/Commons/VgButtonGroupFixed.vue";
import useAuthnStore from "@/store/authn";
import dpApplicationFormStore from "@/store/dp-application-form-store";

export default {
  name: "myElectronicPass",
  components: {
    VgPassCardPicker,
    VgButton,
    VgButtonGroup,
    "van-image": Image,
    "van-button": Button,
    "van-icon": Icon,
    // "van-cell": Cell,
    // EqCell,
    // "van-popup": Popup,
    // "van-picker": Picker,
    "van-overlay": Overlay,
  },
  props: {},
  data() {
    return {
      srcLogo1: srcLogo,
      defaultLogo: defaultPicture,
      time: '2022-09-13',
      qrcodeTest: undefined,
      show: false,

      passCardInfo: null,
      timer: 0,
      passCardList: [],

      showNotes: false,
      srcClose: srcClose,
      srcExpired: srcExpired,
      srcIneffective: srcIneffective,
      srcCancelled: srcCancelled,

      noteTitle: "使用须知",
      noteContent: "1.在本广场非营业/办公时间进出，必须走专用通道。\n" +
          "2.此证仅限本人使用，严禁借用、冒用。一经发现，广场管理中心有权予以注销此证，并驱逐冒用、借用人，并给予处罚。\n" +
          "3.在本广场施工期间，应遵守本广场的各项规章制度。\n" +
          "4.妥善使用此证，配合保安部门检查，接受施工监督。\n" +
          "5.如已过期或无法使用，请前往物业管理中心。\n",
    };
  },
  created() {

  },
  mounted() {
    this.getMyPassCard();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  computed: {
    isEmpty() {
      return !this.passCardInfo;
    },
    isActive() {
      return this.passCardInfo.passCardStatus === "DONE";
    },
    isExpired() {
      return this.passCardInfo.passCardStatus === "EXPIRED";
    },
    isIneffective() {
      return this.passCardInfo.passCardStatus === "INEFFECTIVE";
    },
    isCancelled() {
      return this.passCardInfo.passCardStatus === "CANCELLED";
    },
    userName() {
      return this.passCardInfo.hostName;
    },
    userPhone() {
      return this.passCardInfo.phoneNum;
    },
    validTime() {
      if (new Date(this.passCardInfo.expireTime.replace(/-/g, '/')) > new Date('2998-12-31T23:59:59.00Z')) {
        return "有效期：无限制"
      }
      if (this.passCardInfo.passCardType === "TENANT_EMPLOYEE") {
        return "有效期至：" + (this.passCardInfo.expireTime ? this.passCardInfo.expireTime.slice(0, 10) : "");
      }
      return "有效期：" + (this.passCardInfo.effectTime ? this.passCardInfo.effectTime.slice(0, 16) : "")
          + " 至 " + (this.passCardInfo.expireTime ? this.passCardInfo.expireTime.slice(0, 16) : "");
    },
    canOperate() {
      const authn = useAuthnStore();
      return authn.user?.loginType === "CONSTRUCTION_MANAGER" || authn.user?.loginType === "TENANT";
    },
  },
  methods: {
    qrcode(code, color) {
      this.$nextTick(() => {
        document.getElementById("qrcode").innerHTML = '';
        this.qrcodeTest = new QRCode("qrcode", {
          text: code,
          width: 240,
          height: 240,
          colorDark: color,
          colorLight: "#fff",
          correctLevel: QRCode.CorrectLevel.H
        });
      })
      // console.log(this.qrcodeTest)
    },
    clickApply() {
      // const authn = useAuthnStore();
      dpApplicationFormStore().reset()
      this.$router.push({name: 'digital-passes-applications-form'});
      // if (authn.user?.loginType === "CONSTRUCTION_MANAGER") {
      //   //施工人员
      //   this.$router.push({path: '/applyForAnElectronicPass'});
      // } else if (authn.user?.loginType === "TENANT") {
      //   //租户人员
      //   this.$router.push({path: '/tenantPersonnel'});
      // }
    },
    onApplicationRecord() {
      this.$router.push({path: '/digital-passes/applications'});
    },
    viewProfile() {
      this.$router.push({
        path: '/decorationPersonnelInformation',
        query: {passCardApplicationInfoId: this.passCardInfo.passCardApplicationInfoId}
      });
    },
    switchTheElectronicPass() {
      //切换电子出入证
      client.get("/api/h5/passcard/list").then((res) => {
        this.passCardList = res.data;
        this.show = true;
      });
    },
    onNotes() {
      Dialog.alert({
        messageAlign: 'left',
        title: '使用须知',
        message: "1.在本广场非营业/办公时间进出，必须走专用通道。\n" +
            "2.此证仅限本人使用，严禁借用、冒用。一经发现，广场管理中心有权予以注销此证，并驱逐冒用、借用人，并给予处罚。\n" +
            "3.在本广场施工期间，应遵守本广场的各项规章制度。\n" +
            "4.妥善使用此证，配合保安部门检查，接受施工监督。\n" +
            "5.如已过期或无法使用，请前往物业管理中心。\n",
      }).then(() => {
        // on close
      });
      // this.showNotes = true;
    },
    onRefresh() {
      this.refreshQRCode();
    },
    getMyPassCard() {
      client.get("/api/h5/passcard/info").then((res) => {
        this.passCardInfo = res.data;
        if (!this.isEmpty) {
          this.refreshQRCode();
        }
      });
    },
    refreshQRCode() {
      if (this.isActive) {
        client.get("/api/h5/passcard/refresh-qr" + "?id=" + this.passCardInfo.id).then((res) => {
          this.$toast.success({
            message: '刷新成功',
            duration: 300
          })
          this.qrcode(res.data.code, "#000");
          clearInterval(this.timer);
          this.timer = setInterval(() => this.refreshQRCode(), 1000 * res.data.refreshInterval);
        });
      } else {
        this.qrcode(this.passCardInfo.passCardStatus, "#EDEBED");
        clearInterval(this.timer);
      }
    },
    onUpdateShow(val) {
      this.show = val;
    },
    onConfirm(item) {
      client.post("/api/h5/passcard/switch", {id: item.id}).then((res) => {
        this.passCardInfo = res.data;
        if (!this.isEmpty) {
          this.refreshQRCode();
        }
      });
    },
  },
};
</script>
<style scoped>
.my-electronic-pass {
  background-color: #FFFFFF;
  min-height: 100vh;
  min-height: 100dvh;
}

.header {
  padding: 20px 0px 0px 20px;
}

.footer {
  text-align: center;
  padding-bottom: 19%;
  margin-top: 80%;
  /* display: block;
  margin: auto;
  position: relative;
  top: calc(100% - 35px - 30px); */
}

.box-active {
  border: 5px solid #4BA9F6;
}

.box-expired {
  border: 5px solid #646464;
}

.box-ineffective {
  border: 5px solid #71C57C;
}

.box-cancelled {
  border: 5px solid #FF3434;
}

.text-active {
  color: #4BA9F6;
  font-size: 16px;
}

.text-expired {
  color: #646464;
  font-size: 16px;
}

.text-ineffective {
  color: #71C57C;
  font-size: 16px;
}

.text-cancelled {
  color: #FF3434;
  font-size: 16px;
}

.qrmask {
  position: absolute;
  top: 45px;
  left: 20px;
  z-index: 1;
}


.person {
  width: auto;
  margin: 30px 20px 0;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #EDEBED;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.item-content {
}

.item-entry {
  margin-top: 10px;
  display: flex;
  align-items: flex-start;
}

.item-title {
  min-width: 80px;
  font-size: 16px;
  color: #B4B4B4;
}

.item-text {
  font-size: 16px;
  color: #101010;
}

.item-arrow {
  margin-left: 15px;
  float: right;
  height: 20px;
  width: 20px;
  background-image: url("@/assets/right_arrow.svg");
}


.notes {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.notes-vg {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.notes-bg {
  padding: 20px;
  width: 300px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.notes-title {
  color: #101010;
  font-size: 18px;
}

.notes-content {
  margin-top: 25px;
  margin-bottom: 10px;
  color: #101010;
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-wrap;
}

</style>
